const NotFoundPage = () => import('@/Pages/En/NotFoundPage.vue');
const ServerError = () => import('@/Pages/En/ServerErrorPage.vue');

export const errorRoutes = [
  {
    path: '/500',
    name: 'server-error',
    component: ServerError,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: NotFoundPage,
  },
];
